import React from 'react';

import { IOfferType } from '../../../types/offerTypeList';
import { FOfferType } from '../../../utils/category';

import { CheckboxLabel } from '../../../components/CheckboxLabel';

export const OFFER_TYPES_RENT_COMMERCIAL: IOfferType[][] = [
  [
    { label: 'Офис', value: FOfferType.Office },
    {
      label: <CheckboxLabel label="Коворкинг" postfixType="new" />,
      value: FOfferType.Coworking,
    },
    { label: 'Торговая площадь', value: FOfferType.TradeArea },
    { label: 'Склад', value: FOfferType.Warehouse },
    { label: 'Помещение свободного назначения', value: FOfferType.FreeAppointmentObject },
    { label: 'Общепит', value: FOfferType.PublicCatering },
    { label: 'Производство', value: FOfferType.Manufacture },
    { label: 'Автосервис', value: FOfferType.AutoService },
    { label: 'Здание', value: FOfferType.Building },
    { label: 'Бытовые услуги', value: FOfferType.DomesticServices },
  ],
  [{ label: 'Коммерческая земля', value: FOfferType.CommercialLand }],
];
